import { configResponsive } from 'ahooks';

export const setupResponsiveness = () => {
  configResponsive({
    // bootstrap numbers
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1600,
  });
};

export const mediaQuery = {
  smFrom: `min-width: 576px`,
  mdFrom: `min-width: 768px`,
  lgFrom: `min-width: 992px`,
  xlFrom: `min-width: 1200px`,
};
